<app-data-grid
  [dataItems]="pricingExceptions"
  [columns]="columns"
  [state]="state"
  (dataStateChange)="onDataStateChanged($event)"
  (filterChange)="filterChanged($event)"
  [filterable]="'menu'"
  [fontSize]="fontSize"
>
  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="restaurantName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="parItemId"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="plu"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template
    filterTemplate
    let-column="column"
    let-filterService="filterService"
    field="itemName"
  >
    <app-custom-filter
      [view]="customFilterView"
      [lazy]="false"
      [filter]="state.filter"
      [preselected]="filterCache.get(column.field) || []"
      (filterChanged)="
        onCustomFilterChange(column.field, $event, filterService)
      "
      [field]="column.field"
      [type]="column.type"
    ></app-custom-filter>
  </ng-template>

  <ng-template #toolbarTemplate>
    <div class="k-toolbar k-grid-toolbar custom-toolbar">
      <div class="filters-section">
        <h4 class="m-0">Tier</h4>
        &nbsp;
        <kendo-dropdownlist
          [data]="tiers"
          [(ngModel)]="selectedTier"
          textField="name"
          valueField="id"
          (ngModelChange)="onToolbarFilterChange()"
        ></kendo-dropdownlist>
        &nbsp;
        <h4 class="m-0">Type</h4>
        &nbsp;
        <kendo-dropdownlist
          [data]="itemTypes"
          [(ngModel)]="selectedItemType"
          textField="name"
          valueField="id"
          (ngModelChange)="onToolbarFilterChange()"
        ></kendo-dropdownlist>
      </div>

      <kendo-toolbar-spacer></kendo-toolbar-spacer>

      <div class="buttons-section">
        <app-grid-manager-toolbar
          [showConfig]="false"
          (exportToExcel)="exportExceptions()"
          [fontSize]="fontSize"
          (fontSizeChange)="fontSize = $event"
          [columns]="columns"
          [view]="'Delivery Exceptions'"
          [showImport]="[]"
          [showExport]="['Current Type']"
        ></app-grid-manager-toolbar>
      </div>
    </div>
  </ng-template>
</app-data-grid>
